import { Box, Container, SimpleGrid } from "@chakra-ui/react";
import React, { useState, useEffect} from "react";

declare global {
    interface Window {
        googletag: any;
    }
}

const FeaturedAdBlock = ({ page, block }) => {

    useEffect(() => {
        window.googletag.cmd.push(function () {
            window.googletag.pubads().setTargeting("entry-id", page.number_id);
            window.googletag.pubads().enableSingleRequest();
            window.googletag.pubads().collapseEmptyDivs();
            window.googletag.enableServices();

            window.googletag.display('div-gpt-ad-1725550021431-0');
            window.googletag.display('div-gpt-ad-1725550052100-0');
            window.googletag.display('div-gpt-ad-1725550083230-0');

            window.googletag.pubads().addEventListener('slotRenderEnded', function (ad) {
                if (ad.isEmpty) {
                    const elementId = ad.slot.getSlotElementId();
                    const el = document.getElementById(elementId);
                    if (el) {
                        const adEle = el.parentNode as HTMLElement;
                        if (adEle) {
                            adEle.classList.add('is-hidden');
                        }
                    }
                }
            });
        });
    }, []);

    return (
        <Box className="signals-wrapper" pt={10} pb={10}>
            <Container maxW={'7xl'}>
                <SimpleGrid columns={{ base: 1, md: 1, lg: 3 }} spacing={2}>
                    <Box>
                    <div id='div-gpt-ad-1725550021431-0'>
                    </div>
                    </Box>
                    <Box>
                    <div id='div-gpt-ad-1725550052100-0'>
                    </div>
                    </Box>
                    <Box>
                    <div id='div-gpt-ad-1725550083230-0'>
                    </div>
                    </Box>
                </SimpleGrid>
            </Container>
        </Box>
    )
};

export default FeaturedAdBlock;